var exports = {
  "VZ": "x28a7bf27--afd5b3--banks-list",
  "rE": "x28a7bf27--afd5b3--bank",
  "pB": "x28a7bf27--afd5b3--bank-icon",
};

module.exports = exports;
